export interface IBppFormFourthSectionInterface{
    AssetsWereSameAsPreviousYear?: boolean
}

export const FourthSectionInitialState = {
    AssetsWereSameAsPreviousYear: undefined
}